exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.dropdown-menu {\n    /* margin-left: -500px; */\n    left: 0 !important;\n}", ""]);

// exports
